import React from 'react';

export const AcceptTerms = React.lazy(() => import('./AcceptTerms'));
